// removed by extract-text-webpack-plugin
module.exports = {"base":"WGCWXRewards_base--20HDQ","hangar":"WGCWXRewards_hangar--3AO3B","container":"WGCWXRewards_container--1ZmAY","content":"WGCWXRewards_content--1KL5I","title":"WGCWXRewards_title--1cNlK","category":"WGCWXRewards_category--sE1Au","body":"WGCWXRewards_body--2zJTF","grid":"WGCWXRewards_grid--2i6TR","requirements":"WGCWXRewards_requirements--2Y2Hv","highlight":"WGCWXRewards_highlight--1ZQgh","highlight__red":"WGCWXRewards_highlight__red--2aieR","highlightRed":"WGCWXRewards_highlight__red--2aieR"};


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXRewards/WGCWXRewards.scss
// module id = 578
// module chunks = 11